import { render } from "./FeedbackPage.vue?vue&type=template&id=4df0c2e0&scoped=true"
import script from "./FeedbackPage.vue?vue&type=script&lang=ts"
export * from "./FeedbackPage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4df0c2e0"

export default script